import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const STAFF_SPLIDE_SELECTOR = '#homeMvStaffSplide';
const ABOUT_SPLIDE_SELECTOR = '#aboutSplide';

let staffSplideInstance = null;
let aboutSplideInstance = null;
let pendingAboutSplidePlay = false;

function destroyHomeStaffSplide() {
  if (!staffSplideInstance) {
    return;
  }
  try {
    staffSplideInstance.destroy(true);
  } catch (e) {
    // DOM が既に取り外されている場合など
  }
  staffSplideInstance = null;
}

function initHomeStaffSplide() {
  destroyHomeStaffSplide();

  const root = document.querySelector(STAFF_SPLIDE_SELECTOR);
  if (!root) {
    return;
  }

  const notifyMvStaffSlideChange = () => {
    root.dispatchEvent(
      new CustomEvent('homeMvStaff:slide-changed', {
        bubbles: true,
        detail: {
          root,
          index: staffSplideInstance?.index ?? 0,
        },
      })
    );
  };

  staffSplideInstance = new Splide(root, {
    type: 'fade',
    autoplay: true,
    speed: 800,
    interval: 8000,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    pauseOnHover: false,
    pauseOnFocus: false,
    perPage: 1,
    perMove: 1,
    gap: 0,
    padding: 0,
    trimSpace: true,
    rewind: true,
    arrows: false,
    pagination: false,
    height: '100%',
    drag: false,
    keyboard: 'global',
  });

  staffSplideInstance.on('mounted', notifyMvStaffSlideChange);
  staffSplideInstance.on('moved', notifyMvStaffSlideChange);
  staffSplideInstance.mount();
}

function destroyAboutSplide() {
  if (!aboutSplideInstance) {
    return;
  }
  try {
    aboutSplideInstance.destroy(true);
  } catch (e) {
    // DOM が既に取り外されている場合など
  }
  aboutSplideInstance = null;
  pendingAboutSplidePlay = false;
}

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function initAboutSplide() {
  destroyAboutSplide();

  const root = document.querySelector(ABOUT_SPLIDE_SELECTOR);
  if (!root) {
    return;
  }

  const reducedMotion = prefersReducedMotion();

  aboutSplideInstance = new Splide(root, {
    type: 'loop',
    focus: 'center',
    perPage: 3,
    gap: '10px',
    arrows: false,
    pagination: false,
    drag: reducedMotion ? false : 'free',
    autoScroll: {
      speed: 1,
      autoStart: false,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    breakpoints: {
      1024: {
        perPage: 2,
        gap: '10px',
      },
      767: {
        perPage: 2,
        gap: '5px',
      },
    },
  });

  if (reducedMotion) {
    aboutSplideInstance.mount();
    return;
  }

  aboutSplideInstance.mount({ AutoScroll });

  if (pendingAboutSplidePlay) {
    aboutSplideInstance.Components?.AutoScroll?.play();
    pendingAboutSplidePlay = false;
  }
}

export function playAboutSplideAutoScroll() {
  const autoScroll = aboutSplideInstance?.Components?.AutoScroll;
  if (autoScroll) {
    autoScroll.play();
    pendingAboutSplidePlay = false;
    return;
  }
  pendingAboutSplidePlay = true;
}

function initSplides() {
  initHomeStaffSplide();
  initAboutSplide();
}

initSplides();
document.addEventListener('swup:replaced', initSplides);
